import FilterNav from "../../molecules/filterNav/FilterNav";
import Slider from "../../atoms/slider/Slider";
import styles from "./PriceMobileItem.module.scss";
import LabelText from "../../atoms/label/LabelText";
import ButtonBox from "../../atoms/buttonBox/ButtonBox";

const DataVmAirtimeMobileItem = (props) => {
  const onSliderChangeData = (value) => {
    props.selectDataMobile(value);
  };

  const onSliderChangeVoiceMin = (value) => {
    props.selectVMMobile(value);
  };

  const onSliderChangeAirTime = (value) => {
    props.selectAirtimeMob(value);
  };

  const resetData = () => {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  const handleBack = () => {
    resetData();
    props.hideDataVmAirtime();
  };

  return (
    <div className={styles.navGutter}>
      <FilterNav
        headingName="Monthly data / voice minutes / airtime"
        backbtn={handleBack}
        resetClickHandler={props.resetClickHandler}
        selectedFilter={props.selectedFilter}
      />
      <div className={styles.priceContainer}>
        <LabelText>Data</LabelText>
        <div className={styles.slider}>
          <Slider
            sliderChange={(value) => onSliderChangeData(value)}
            label1=""
            label2=""
            minValue={props.minValue}
            maxValue={props.maxValue}
            min={props.min}
            max={props.max}
            rightLabel="GB"
            sliderType="data"
            step={30}
          />
        </div>
      </div>

      <div className={styles.priceContainer}>
        <LabelText>Voice minutes</LabelText>
        <div className={styles.slider}>
          <Slider
            sliderChange={(value) => onSliderChangeVoiceMin(value)}
            label1="min"
            minValue={props.minValueVm}
            maxValue={props.maxValueVm}
            min={props.minVm}
            max={props.maxVm}
            rightLabel="min"
            sliderType="Voice"
            unlimited={true}
          />
        </div>
      </div>

      <div className={styles.priceContainer}>
        <LabelText>Airtime</LabelText>
        <div className={styles.slider}>
          <Slider
            sliderChange={(value) => onSliderChangeAirTime(value)}
            label1="R"
            minValue={props.minValueAir}
            maxValue={props.maxValueAir}
            min={props.minAir}
            max={props.maxAir}
            rightLabel=""
            sliderType="airtime"
          />
        </div>
      </div>
      <ButtonBox
        children="Save Selection"
        className={styles["botton-box"]}
        click={props.hideDataVmAirtime}
      />
    </div>
  );
};

export default DataVmAirtimeMobileItem;
